import { BiUtils, getSearchParams } from '@wix/package-picker-shared';
import { v4 } from 'uuid';
import { eclipseServerData } from '../../utils';
import { useCurrentModule } from '../../components';
const biEventAggregator = v4();
export const getStaticBiEventsFields = () => {
  const {
    referralAdditionalInfo,
    siteGuid,
    isDowngradeEnabled
  } = getSearchParams();
  const {
    referrer
  } = eclipseServerData.get();
  return {
    abTesting: 'purchase_wix_plan_static',
    packagePickerType: 'eclipse',
    project: 'package-picker-eclipse',
    eventAggregator: biEventAggregator,
    referralAdditionalInfo,
    referrer,
    siteGuid,
    siteId: siteGuid,
    msid: siteGuid,
    flowType: isDowngradeEnabled ? 'downgrade' : 'upgrade',
    cartFlow: 'classic',
    ppType: 'business',
    intent: 'Default'
  };
};
export const useCommonBiEventsFields = function (_temp) {
  var _currentProductStatus, _currentProductStatus2, _currentProductQuery$, _offeringQuery$data;
  let {
    enabled = true
  } = _temp === void 0 ? {
    enabled: true
  } : _temp;
  const module = useCurrentModule();
  const staticBiEventsFields = getStaticBiEventsFields();
  const currentProductStatusQuery = module.SDK.switchApiClient.hooks.useGetCurrentProductStatus({}, enabled);
  const currentProductQuery = module.SDK.switchApiClient.hooks.useGetCurrentProduct({}, enabled);
  const offeringQuery = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const changePlanType = BiUtils.getBiChangePlanType((_currentProductStatus = currentProductStatusQuery.data) == null ? void 0 : _currentProductStatus.status);
  const commonBiEventsFields = {
    ...staticBiEventsFields,
    newPurchase: ((_currentProductStatus2 = currentProductStatusQuery.data) == null ? void 0 : _currentProductStatus2.status) === 'noCurrentProduct' ? 'true' : 'false',
    changePlanType,
    currentProductGuid: (_currentProductQuery$ = currentProductQuery.data) == null || (_currentProductQuery$ = _currentProductQuery$.currentProduct) == null ? void 0 : _currentProductQuery$.productId,
    offeringType: BiUtils.getBiOfferingType((_offeringQuery$data = offeringQuery.data) == null || (_offeringQuery$data = _offeringQuery$data.discountInfo) == null || (_offeringQuery$data = _offeringQuery$data.sale) == null ? void 0 : _offeringQuery$data.saleType)
  };
  const isLoading = currentProductStatusQuery.isLoading || currentProductQuery.isLoading || offeringQuery.isLoading;
  return {
    commonBiEventsFields,
    isLoading,
    enabled
  };
};
//# sourceMappingURL=useCommonBiEventsFields.js.map